import uniqueId from 'lodash/uniqueId';
import type { HTMLAttributes } from 'react';
import styled, { keyframes } from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';

const loading = keyframes`
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
`;

const StyledSkeleton = styled.div<{
  $color?: string;
  $width?: string;
}>`
  width: ${({ $width }) => $width};
  height: 19px;
  border-radius: 80px;
  background-color: ${({ $color }) => $color || colors.ink20};
  animation: ${loading} 1.5s infinite ease-in-out;
  margin-bottom: 2px;
`;

type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  color?: string;
  linesWidth: string[];
};

const Skeleton = ({ color, linesWidth, ...props }: SkeletonProps) =>
  linesWidth.map((width) => <StyledSkeleton key={uniqueId()} $color={color} $width={width} {...props} />);

export default Skeleton;
